import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import api from '../services/api';

const PlantillasList = () => {
    const navigate = useNavigate();
    const [plantillas, setPlantillas] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        cargarPlantillas();
    }, []);

    const cargarPlantillas = async () => {
        try {
            const response = await api.plantillas.getAll();
            setPlantillas(response.data || []);
        } catch (err) {
            console.error('Error al cargar plantillas:', err);
            toast.error('Error al cargar plantillas');
        } finally {
            setLoading(false);
        }
    };

    const handleEliminar = async (id, nombre) => {
        toast((t) => (
            <div>
                <p>¿Eliminar plantilla "{nombre}"?</p>
                <div style={{ display: 'flex', gap: '8px', marginTop: '8px' }}>
                    <button
                        className="btn neon small"
                        onClick={async () => {
                            toast.dismiss(t.id);
                            try {
                                await api.plantillas.delete(id);
                                toast.success('Plantilla eliminada');
                                cargarPlantillas();
                            } catch (err) {
                                toast.error('Error al eliminar');
                            }
                        }}
                    >
                        Sí, eliminar
                    </button>
                    <button
                        className="btn ghost small"
                        onClick={() => toast.dismiss(t.id)}
                    >
                        Cancelar
                    </button>
                </div>
            </div>
        ), { duration: 10000 });
    };

    if (loading) {
        return <div className="loading">Cargando plantillas...</div>;
    }

    return (
        <div className="card">
            <div className="card-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2>Plantillas de Cotización</h2>
                <button
                    className="btn neon"
                    onClick={() => navigate('/plantillas/nueva')}
                >
                    + Nueva Plantilla
                </button>
            </div>

            <div className="card-body">
                {plantillas.length === 0 ? (
                    <div className="empty-state">
                        <p>No hay plantillas creadas</p>
                        <p style={{ color: 'var(--muted)', fontSize: '14px', marginTop: '8px' }}>
                            Las plantillas te permiten crear cotizaciones rápidamente con servicios predefinidos
                        </p>
                    </div>
                ) : (
                    <div className="plantillas-grid">
                        {plantillas.map((plantilla) => (
                            <div key={plantilla.id} className="plantilla-card">
                                <div className="plantilla-card-header">
                                    <h3>{plantilla.nombre}</h3>
                                    <span className={`badge ${plantilla.activo ? 'active' : 'inactive'}`}>
                                        {plantilla.activo ? 'Activo' : 'Inactivo'}
                                    </span>
                                </div>
                                {plantilla.descripcion && (
                                    <p className="plantilla-descripcion">{plantilla.descripcion}</p>
                                )}
                                <div className="plantilla-meta">
                                    <span>{plantilla.servicios_count || 0} servicios</span>
                                    <span>{plantilla.extras_count || 0} extras</span>
                                </div>
                                <div className="plantilla-actions">
                                    <button
                                        className="btn ghost small"
                                        onClick={() => navigate(`/plantillas/${plantilla.id}`)}
                                    >
                                        Editar
                                    </button>
                                    <button
                                        className="btn ghost small danger"
                                        onClick={() => handleEliminar(plantilla.id, plantilla.nombre)}
                                    >
                                        Eliminar
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PlantillasList;
